const data = {
  SyntheticGround: 'Синтетическое покрытие',
  ModularCovering: 'Модульное покрытие',
  SyntheticGrass: 'Иск. газон',
  SyntheticIce: 'Иск. лед',
  RubberTile: 'Резиновая плитка',
  Tarafleks: 'Тарафлекс',
  Asphalt: 'Асфальт',
  Parquet: 'Паркет',
  Carpet: 'Ковер',
  Rubber: 'Резина',
  Грунт: 'Грунт',
  Grass: 'Нат. газон',
  Clay: 'Глина',
  Hard: 'Хард',
  Sand: 'Песок',
  Ice: 'Лед',
};

const reducer = (state = data) => state;

export default reducer;
